import { useState } from "react";
import { Card, List, Typography, Button, Space, Flex } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

import { SideNavPageLayout } from "shared/components";
import { IOrganization } from "organizations/models";
import { useBoundStore } from "store";
import { buildDashboardPath } from "shared/utils/paths";
import { CreateOrganizationModal } from "organizations/components/CreateOrganizationModal";

export const Organizations = () => {
  const navigate = useNavigate();
  const { organizations, tenant, user } = useBoundStore();
  const [showCreateModal, setShowCreateModal] = useState(false);

  const isTenantAdmin = user?.role === "owner" || user?.role === "admin";

  const onSelectOrganization = async (organization: IOrganization) => {
    navigate(buildDashboardPath(organization));
  };

  return (
    <SideNavPageLayout title='Organizations'>
      <Space direction='vertical' size='large' style={{ width: "100%" }}>
        <Flex justify='space-between' align='center'>
          {tenant && (
            <div>
              <Typography.Title level={4} style={{ marginBottom: 4 }}>
                {tenant.name}
              </Typography.Title>
              <Typography.Text type='secondary' copyable={{ text: tenant.id }}>
                Tenant ID: {tenant.id}
              </Typography.Text>
            </div>
          )}
          {isTenantAdmin && (
            <Button
              type='primary'
              icon={<PlusOutlined />}
              onClick={() => setShowCreateModal(true)}
            >
              Add Organization
            </Button>
          )}
        </Flex>
        <Card
          title='Choose an organization'
          extra={
            <Typography.Text type='secondary'>
              Select an organization to continue to the dashboard.
            </Typography.Text>
          }
        >
          <List
            dataSource={organizations}
            locale={{
              emptyText: (
                <Typography.Text>
                  No organizations found for this tenant.
                </Typography.Text>
              ),
            }}
            renderItem={(organization) => (
              <List.Item
                actions={[
                  <Button
                    key='go-to-dashboard'
                    type='primary'
                    onClick={() => onSelectOrganization(organization)}
                  >
                    Go to dashboard
                  </Button>,
                ]}
              >
                <Flex vertical gap={4}>
                  <Typography.Text strong>{organization.name}</Typography.Text>
                  {organization.description && (
                    <Typography.Text type='secondary'>
                      {organization.description}
                    </Typography.Text>
                  )}
                  <Typography.Text type='secondary' copyable={{ text: organization.id }}>
                    Org ID: {organization.id}
                  </Typography.Text>
                </Flex>
              </List.Item>
            )}
          />
        </Card>
      </Space>
      <CreateOrganizationModal
        open={showCreateModal}
        onClose={() => setShowCreateModal(false)}
      />
    </SideNavPageLayout>
  );
};
